import { render, staticRenderFns } from "./sina_weibo.vue?vue&type=template&id=95d608b4&scoped=true&"
import script from "./sina_weibo.vue?vue&type=script&lang=js&"
export * from "./sina_weibo.vue?vue&type=script&lang=js&"
import style0 from "./sina_weibo.vue?vue&type=style&index=0&id=95d608b4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d608b4",
  null
  
)

export default component.exports